/* eslint-disable max-len */
import axios from "axios";
import { baseURL } from "../config";
import { dataService } from "./data.services";


async function verifyPreference(payload) {
    // const idToken = sessionStorage.getItem("IdToken");
    // const headers = {
    //     Authorization: `Bearer ${idToken}`,
    // };
    const idToken = localStorage.getItem("IdToken")!==null?localStorage.getItem("IdToken"):sessionStorage.getItem('IdToken');
    const headers = {
        Authorization: `Bearer ${idToken}`,
    };
    try {
        const data = await axios.post(`${baseURL}users/add-preference`, payload,{
            headers: headers,
        });
        return {error: false, data: data.data};
    } catch (error) {
        return {error: true, message: error};
    }
}
async function verifyOtp(payload) {
    const idToken = localStorage.getItem("IdToken")!==null?localStorage.getItem("IdToken"):sessionStorage.getItem('IdToken');
    const headers = {
        Authorization: `Bearer ${idToken}`,
    };
    try {
        const data = await axios.post(`${baseURL}users/preference`, payload,{
            headers: headers,
        });
        return {error: false, data: data.data};
    } catch (error) {
        return {error: true, message: error};
    }
}
async function DuplicateTabClose() {
    const idToken = localStorage.getItem("IdToken")!==null?localStorage.getItem("IdToken"):sessionStorage.getItem('IdToken');
    const headers = {
        Authorization: `Bearer ${idToken}`,
    };
    let payload = {
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    }
    try {
        const data = await axios.post(`${baseURL}users/clear-session`,payload,{
            headers: headers,
        });
        return {error: false, data: data.data};
    } catch (error) {
        return {error: true, message: error};
    }
}
async function preferenceList() {
    const idToken = localStorage.getItem("IdToken")!==null?localStorage.getItem("IdToken"):sessionStorage.getItem('IdToken');
    const headers = {
        Authorization: `Bearer ${idToken}`,
    };
    try {
        const data = await axios.get(`${baseURL}users/preference`,{
            headers: headers,
        });
        return {error: false, data: data.data};
    } catch (error) {
        return {error: true, message: error};
    }
}

async function getCountryCodes() {
    let payload = {};
    
    // payload = JSON.stringify(payload);
    try {
        const data = await axios.get('https://restcountries.com/v2/all?fields=name,alpha3Code,callingCodes');
        return {error: false, data: data.data};
    } catch (error) {
        return {error: true, message: error};
    }
}
async function resetPassword(endpoint,payload) {
    //payload = JSON.stringify(payload);
    const idToken = localStorage.getItem("IdToken")!==null?localStorage.getItem("IdToken"):sessionStorage.getItem('IdToken');
    const headers = {
        Authorization: `Bearer ${idToken}`,
    };
    try {
        const data = await axios.patch(`${baseURL}${endpoint}`, payload,{
            headers: headers,
        });
        return {error: false, data: data};
    } catch (error) {
        return {error: true, message: error};
    }
}
async function forgotPassword(email, payload) {
    // payload = JSON.stringify(payload);
    try {
        const data = await axios.post(`${baseURL}${email}`, payload);
        return {error: false, data: data.data};
    } catch (error) {
        return {error: true, message: error};
    }
}

async function login(email, password,browserId) {
    let payload = {
        user_name: email,
        password: password,
        browser_id: browserId.toString(),
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
    try {
        const data = await axios.post(`${baseURL}users/login`, payload);
        return {error: false, data: data.data};
    } catch (error) {
        return {error: true, message: error};
    }
}

async function sendOtptoPreference(preference_id) {
    const sessionToken =localStorage.getItem("session_token")!==null?localStorage.getItem("session_token"):sessionStorage.getItem('session_token');
    let payload = {
        session_token: sessionToken,
        preference_id: preference_id,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,

    };
    try {
        const data = await axios.post(`${baseURL}users/login/send-otp`, payload);
        return {error: false, data: data.data};
    } catch (error) {
        return {error: true, message: error};
    }
}

async function verifyLoginOtp(otp) {
    const sessionToken = localStorage.getItem("verify_otp_session_token")!==null?localStorage.getItem("verify_otp_session_token"):sessionStorage.getItem('verify_otp_session_token');
    let payload = {
        session_token: sessionToken,
        otp: otp,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
    try {
        const data = await axios.post(`${baseURL}users/login/verify-otp`, payload);
        return {error: false, data: data.data};
    } catch (error) {
        return {error: true, message: error};
    
    }
}

async function RefreshToken() {
    const idToken = localStorage.getItem("IdToken")!==null?localStorage.getItem("IdToken"):sessionStorage.getItem('IdToken');
    const refreshToken = localStorage.getItem("RefreshToken")!==null?localStorage.getItem("RefreshToken"):sessionStorage.getItem('RefreshToken');
    const body = {
        refresh_token: refreshToken,
        user_type:localStorage.getItem("user_type")!==null?localStorage.getItem("user_type"):sessionStorage.getItem('user_type')
    }
    const headers = {
        Authorization: `Bearer ${idToken}`,
    };
    try {
        const data = await axios.post(`${baseURL}users/refresh-token`, body ,{
            headers: headers,
        });
        return {error: false, data: data.data};
    } catch (error) {
        console.log('refreshtoken error',error)
        //sessionStorage.setItem('custom-status', 'inactive');
        return {error: true, message: error};
    }
}

async function resendOtp(preference_id) {
    const sessionToken = localStorage.getItem("session_token");
    let payload = {
        session_token: sessionToken,
        preference_id: preference_id,
        type: "resend-otp",
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
    try {
        const data = await axios.post(`${baseURL}users/login/send-otp`, payload);
        return {error: false, data: data.data};
    } catch (error) {
        return {error: true, message: error};
    
    }
}

async function logout() {
    const idToken = localStorage.getItem("IdToken")!==null?localStorage.getItem("IdToken"):sessionStorage.getItem('IdToken')
    const refreshToken = localStorage.getItem("RefreshToken")!==null?localStorage.getItem("RefreshToken"):sessionStorage.getItem('RefreshToken')
    const access_token = localStorage.getItem("AccessToken")!==null?localStorage.getItem("AccessToken"):sessionStorage.getItem('AccessToken')
    const headers = {
        Authorization: `Bearer ${idToken}`,
    };
    let payload = {
        "token" : refreshToken,
        "user_type":localStorage.getItem('user_type'),
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    }
    try {
        const data = await axios.post(`${baseURL}users/logout`,payload,{
            headers: headers,
        });
        return {error: false, data: data.data};
    } catch (error) {
        return {error: true, message: error};
    }
}
async function DuplicateLogout() {
    const idToken = localStorage.getItem("IdToken")!==null?localStorage.getItem("IdToken"):sessionStorage.getItem('IdToken')
    const refreshToken = localStorage.getItem("RefreshToken")!==null?localStorage.getItem("RefreshToken"):sessionStorage.getItem('RefreshToken')
    const access_token = localStorage.getItem("AccessToken")!==null?localStorage.getItem("AccessToken"):sessionStorage.getItem('AccessToken')
    const headers = {
        Authorization: `Bearer ${idToken}`,
    };
    let payload = {
        "token" : refreshToken,
        "user_type":localStorage.getItem('user_type'),
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    }
    try {
        const data = await axios.post(`${baseURL}users/logout?type=clear-session`,payload,{
            headers: headers,
        });
        return {error: false, data: data.data};
    } catch (error) {
        return {error: true, message: error};
    }
}
async function CancelDuplicatelogin() {
    let payload = {
        user_name: localStorage.getItem('email'),
        user_type: localStorage.getItem('user_type'),
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
    try {
        const data = await axios.post(`${baseURL}users/capture-log`, payload);
        return {error: false, data: data.data};
    } catch (error) {
        return {error: true, message: error};
    }
}

async function getUserData() {
    
    // payload = JSON.stringify(payload);
    try {
        const data = await dataService.GetAPI('users/check-status');
        return {error: false, data: data};
    } catch (error) {
        //console.log("eerr",error)
        return {error: true, message: error};
    }
}


async function deletePreference(_id) {
    const idToken = localStorage.getItem("IdToken")!==null?localStorage.getItem("IdToken"):sessionStorage.getItem('IdToken')
    const headers = {
        Authorization: `Bearer ${idToken}`,
    };
    try {
        const data = await axios.delete(`${baseURL}users/preference/${_id}`,{
            headers: headers,
        });
        return {error: false, data: data.data};
    } catch (error) {
        return {error: true, message: error};
    }
}

async function trustMyBrowser(body) {
    const idToken = localStorage.getItem("IdToken")!==null?localStorage.getItem("IdToken"):sessionStorage.getItem('IdToken')
    const id = localStorage.getItem("id")!==null?localStorage.getItem("id"):sessionStorage.getItem('id')
    const headers = {
        Authorization: `Bearer ${idToken}`,
    };
    try {
        const data = await axios.patch(`${baseURL}users/trust-browser/${id}`,body,{
            headers: headers,
        });
        return {error: false, data: data.data};
    } catch (error) {
        return {error: true, message: error};
    }
}

export const userService = {
    getCountryCodes,
    resetPassword,
    forgotPassword,
    login,
    verifyPreference,
    verifyOtp,
    preferenceList,
    resendOtp,
    RefreshToken,
    verifyLoginOtp,
    sendOtptoPreference,
    logout,
    getUserData,
    deletePreference,
    trustMyBrowser,
    DuplicateTabClose,
    DuplicateLogout,
    CancelDuplicatelogin,

}
